export default {
  state: {
    user: null
  },
  mutations: {
    setUserData (state, val) {
      state.user = val;
    },
  },
  actions: {
    getUserData ({ commit }) {
      return axios.get(`/api/passport/users/me`).then((val)=>{
        commit('setUserData', val);
      })
    },
  },
}